module.exports = __webpack_public_path__ + "files/de36ebdc5437f1344887c90fa382a3fd.png";